import React, { useEffect, useState } from "react";
import HubblePageContainer from "./components/HubblePageContainer";
import HubbleBlogFilter from "./components/HubbleBlogFilter";
import MyUploadsElement from "./components/MyUploadsElement";
import { useNavigate } from "react-router";

import { FaArrowLeftLong } from "react-icons/fa6";
import Loading from "../../assets/containers/loadingDialog";
import errorHandler from "../../assets/utils/ErrorHandler";
import {
  getMyUploads,
  removeMyUpload,
} from "../../assets/services/apiServices";
import toast from "react-hot-toast";

const MyUploads = () => {
  const navigate = useNavigate();
  const [myUploads, setMyUploads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchMyUploads();
  }, []);

  const fetchMyUploads = async () => {
    try {
      const response = await getMyUploads();
      setMyUploads(response.data.docs);
    } catch (err) {
      errorHandler(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeletedUpload = async (id) => {
    try {
      setIsLoading(true);
      await removeMyUpload(id);
      toast.success("با موفقیت حدف شد");
      fetchMyUploads()
    } catch (err) {
      errorHandler(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <HubblePageContainer>
        <div className="d-flex my-5 justify-content-center">
          <Loading />
        </div>
      </HubblePageContainer>
    );
  }

  return (
    <HubblePageContainer>
      <div className="d-flex justify-content-between align-items-center py-2">
        <h4>اثر های من</h4>
        <div onClick={() => navigate(-1)}>
          <FaArrowLeftLong size={20} />
        </div>
      </div>
      <HubbleBlogFilter />
      <div className="w-100 mt-4">
        {myUploads.length === 0 ? (
          <p className="my-5 text-center">موردی برای نمایش وجود ندارد</p>
        ) : (
          myUploads.map((item, index) => {
            return (
              <MyUploadsElement
                data={item}
                key={index}
                handleDelete={() => handleDeletedUpload(item._id)}
              />
            );
          })
        )}
      </div>
    </HubblePageContainer>
  );
};

export default MyUploads;
